export const GET_VIDEO_CONTENT = 'GET_VIDEO_CONTENT';
export const SET_VIDEO_CONTENT = `SET_VIDEO_CONTENT`;
